import axios from "axios";
import { isNumber } from "lodash";
import { store } from "./Store";
import { AppState } from "./Reducers/Reducers";

axios.interceptors.request.use((request) => {
    const state = store.getState() as AppState;
    if (
        !request.headers.get('X-Cms-Funnel') &&
        isNumber(state.page.circuit.funnelId) &&
        new URL(
            request.url?.startsWith('http') ?
                request.url :
                window.location.origin + request.url,
        ).origin === window.location.origin
    ) {
        request.headers.set('X-Cms-Funnel', state.page.circuit.funnelId);
    }
    return request;
});

axios.interceptors.response.use((response) => {
    return response;
}, (error) => {
    if (axios.isAxiosError(error)) {
        switch (error.response?.status) {
            case 429: {
                return new Promise((resolve, reject) => {
                    setTimeout(() => {
                        if (error.config) {
                            resolve(axios(error.config));
                        } else {
                            reject(error);
                        }
                    }, 3000);
                })
            }
        }
    }
    return Promise.reject(error);
});
